import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import Sidebar from '@/components/Sidebar';
import Header from '@/components/Header';
import { TrialBanner } from '@/features/billing/components/TrialBanner';
import { useBilling } from '@/features/billing/hooks/useBilling';
import { useIsMobile } from '@/hooks/useMediaQuery';
import { useFocusOnRouteChange } from '@/hooks/useFocusManagement';

export default function DashboardLayout() {
    const isMobile = useIsMobile();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const mainRef = useFocusOnRouteChange();
    const billing = useBilling();

    return (
        <div className="flex h-screen bg-gray-50">
            {/* Desktop sidebar */}
            {!isMobile && (
                <Sidebar />
            )}

            {/* Main content area */}
            <div className="flex flex-1 flex-col overflow-hidden">
                {/* Trial banner — shown globally when tenant is on a trial */}
                <TrialBanner
                    daysLeft={billing.trialDaysLeft}
                    isTrialing={billing.isTrialing}
                />

                {isMobile && (
                    <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
                        <SheetTrigger asChild>
                            <Button
                                variant="ghost"
                                size="icon"
                                className="touch-target"
                                aria-label="Open navigation menu"
                            >
                                <Menu className="h-5 w-5" aria-hidden="true" />
                            </Button>
                        </SheetTrigger>
                        <SheetContent side="left" className="w-64 p-0">
                            <Sidebar
                                onNavigate={() => setSidebarOpen(false)}
                            />
                        </SheetContent>
                    </Sheet>
                )}

                <Header />

                <main
                    id="main-content"
                    ref={mainRef}
                    className="flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-6 lg:px-8"
                    tabIndex={-1}
                    role="main"
                    aria-label="Main content"
                >
                    <Outlet />
                </main>
            </div>
        </div>
    );
}